











































































import Vue from "vue";
import { Component } from 'vue-property-decorator';

@Component({ name: 'app' })
export default class App extends Vue {
  menu = [
    {text: 'Home', to: 'home'},
    {
      text: 'Dataset', to: 'dataset',
      submenu: [{
        text: 'Download', 'to': 'download',
        disabled: false,
      }, {
        text: 'Explore', 'to': 'explore',
        disabled: true,
      }],
    },
    {
      text: 'Challenge 2018', to: 'challenge',
      submenu: [{
        text: 'ECCV Workshop', to: 'challenge2018',
      },{
        text: 'Guidelines', to: 'guidelines',
        disabled: false,
      },{
        text: 'Workshop Program', to: 'workshop',
      }, {
        text: 'Leaderboard', to: 'leaderboard',
        disabled: false,
      }, ],
    }
  ]
  get route() {
    return this.$route.path;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue